import * as types from '../constants/types'

const initialState = {
  selectedQaState: "",
  selectedState: "LAUNCHED,AWAITING_APPROVAL",
  selectedSearchField: ""
}

export function filter(state = initialState, action) {
  switch(action.type) {
    case types.STATE_FILTER_SELECT_OPTION:
    return {
      ...state,
      selectedState: action.payload
    }
    case types.SEARCH_FILTER_SELECT_OPTION:
    return {
      ...state,
      selectedSearchField: action.payload
    }
    case types.RESET_FILTERS:
    return {
      ...state,
      selectedState: "LAUNCHED,AWAITING_APPROVAL",
      selectedSearchField: ""
    }
    default:
    return state
  }
}